import { PointLight } from 'noodle/engine/light';
import { Scene } from 'noodle/engine/scene/Scene';

export type StressTestSpread = {
  /** Half-extent on X axis (lights oscillate ±x) */
  x: number;
  /** Center height */
  yCenter: number;
  /** Half-extent on Y axis (lights oscillate yCenter ± y) */
  y: number;
  /** Half-extent on Z axis (lights oscillate ±z) */
  z: number;
};

export class StressTestLights {
  private lights: PointLight[] = [];
  private phases: { px: number; py: number; pz: number; cr: number; cg: number; cb: number }[] = [];
  count = 0;

  constructor(
    private scene: Scene,
    private spread: StressTestSpread = { x: 50, yCenter: 30, y: 30, z: 25 },
  ) {}

  setCount(count: number): void {
    while (this.lights.length > count) {
      const light = this.lights.pop()!;
      this.scene.lightManager.removeLight(light);
      this.phases.pop();
    }
    while (this.lights.length < count) {
      const light = new PointLight({
        position: [0, 5, 0],
        innerRange: 5,
        outerRange: 15,
        color: [1, 1, 1],
        shadowMode: 'none',
      });
      this.scene.lightManager.addLight(light);
      this.lights.push(light);
      this.phases.push({
        px: Math.random() * Math.PI * 2,
        py: Math.random() * Math.PI * 2,
        pz: Math.random() * Math.PI * 2,
        cr: Math.random() * Math.PI * 2,
        cg: Math.random() * Math.PI * 2,
        cb: Math.random() * Math.PI * 2,
      });
    }
    this.count = count;
  }

  update(time: number): void {
    const t = time * 0.001;
    const { x, yCenter, y, z } = this.spread;
    for (let i = 0; i < this.lights.length; i++) {
      const light = this.lights[i];
      const p = this.phases[i];

      light.position[0] = Math.sin(t * 0.3 + p.px) * x;
      light.position[1] = yCenter + Math.sin(t * 0.2 + p.py) * y;
      light.position[2] = Math.sin(t * 0.25 + p.pz) * z;
      light.updateBounds();

      light.color[0] = 0.5 + 0.5 * Math.sin(t * 0.15 + p.cr);
      light.color[1] = 0.3 + 0.3 * Math.sin(t * 0.12 + p.cg);
      light.color[2] = 0.2 + 0.3 * Math.sin(t * 0.1 + p.cb);
    }
  }
}
